import { memo, useCallback } from "react";
import { Confirmation } from "./Confirmation";
import { useConfirmation } from "./index";

export const ConfirmationContainer = memo(() => {
  const { confirmations, remove } = useConfirmation();
  const lastConfirmation = confirmations?.[confirmations.length - 1];
  const onRequestClose = useCallback(
    () => setTimeout(() => remove(lastConfirmation?.confirmationId), 0),
    [ lastConfirmation?.confirmationId, remove ],
  );

  if (!lastConfirmation) {
    return null;
  }

  return <Confirmation {...lastConfirmation} isOpen onRequestClose={onRequestClose} />;
});

export default ConfirmationContainer;
